import React from 'react'
import { useSelector } from 'react-redux'

import { StickyAnchor, StickyWrapper, StickyMobileChipWrapper } from './StickyCSHWrapper.styles'

const StickyCSHWrapper = (props) => {
  const {
    children,
    hiddenClassName,
    showStickyHeader,
    stickyCSHAnchorId,
    stickyCSHWrapperId,
    isMobileFilterChip,
  } = props

  const isMultiDestination = useSelector((state) => state.pclnBootstrapData?.isMultiDestination)

  if (showStickyHeader) {
    if (isMobileFilterChip) {
      return <StickyMobileChipWrapper id={'mobileChipStickyWrapper'}>{children}</StickyMobileChipWrapper>
    }

    return (
      <>
        <StickyAnchor hiddenClassName={hiddenClassName} id={stickyCSHAnchorId} isMD={isMultiDestination} />
        <StickyWrapper isMobileFilterChip={isMobileFilterChip} id={stickyCSHWrapperId}>
          {children}
        </StickyWrapper>
      </>
    )
  }

  return children
}

export { StickyCSHWrapper }
